// The card kinds this app draws, sent with every question: the server offers
// only the tools whose cards the app can show.
export const CARD_KINDS = ['invite_draft', 'invite_list', 'staff_invite_draft', 'my_checks'] as const;
export type CardKind = (typeof CARD_KINDS)[number];
